import * as type from '../../types/trans';
import { AUTHMOH, AUTHFOLIO } from '../../types/onboarding';

let init = {
    cvlData: null,
    guestMenu: null,
    onboardAuth: null,
    onboardFolio: null,
    userDetail: null,
    arnDetails: null,
    holderform: null,
    docID: null,//'DID210811124512165NLWEUBULH4PPKD'//null,
    params: null,


}

export default function authDetails(state = init, action) {

    switch (action.type) {
        case type.SAVE_CVL_DATA:
            return {
                ...state,
                cvlData: action.payload
            }
        case type.USER_DETAIL:
            return {
                ...state,
                userDetail: action.payload
            }
        case type.AUTHRESP:
            return {
                ...state,
                arnDetails: action.payload
            }

        case type.UPDATE_GUEST_MENU:
            return {
                ...state,
                guestMenu: true,
            }

        case type.RESET_GUEST_MENU:
            return {
                ...state,
                guestMenu: false,
            }
        case AUTHMOH:
            return {
                ...state,
                onboardAuth: action.payload
            }
        case AUTHFOLIO:
            return {
                ...state,
                onboardFolio: action.payload
            }

        case type.GET_PARAMS:
            return {
                ...state,
                params: action.payload
            }

        default:
            return state
    }
}